import script from "./loan-disbursements-report.vue?vue&type=script&setup=true&lang=js"
export * from "./loan-disbursements-report.vue?vue&type=script&setup=true&lang=js"

import "./loan-disbursements-report.vue?vue&type=style&index=0&id=1b08c646&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b08c646"]])

export default __exports__